import { Component, input } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import {
    TableRowData,
    hasNumberOfDeliveryNotes,
} from '@app/shared/models/table-data-types';
import { ColumnConfig } from '@app/shared/services/view-configs/column-creator';

@Component({
    selector: 'app-bundle-info',
    template: `
        <div class="tw-flex tw-items-center tw-space-x-2">
            <mat-icon
                fontSet="material-symbols-outlined"
                class="tw-text-sm tw-text-gray-500">
                folder
            </mat-icon>
            <span class="tw-font-medium">{{ value() }}</span>
            @if (deliveryNotesCount > 0) {
                <span
                    class="tw-bg-blue-100 tw-text-blue-800 tw-px-1 tw-py-0.5 tw-rounded tw-text-xs">
                    {{ deliveryNotesCount }}
                </span>
            }
        </div>
    `,
    standalone: true,
    imports: [MatIconModule],
})
export class BundleInfoComponent {
    value = input<string>('');
    row = input<TableRowData>();
    column = input<ColumnConfig>();
    index = input<number>(0);

    get deliveryNotesCount(): number {
        const row = this.row();
        return row && hasNumberOfDeliveryNotes(row)
            ? row.numberOfDeliveryNotes
            : 0;
    }
}
